export default __webpack_public_path__ + "static/media/french-rose.49453095.png";